import { createContext, useState } from 'react';



export const Context = createContext();

export const ContextProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(true);
    const [progress, setProgress] = useState(20);
    

   
    return (
        <Context.Provider
            value={{
                darkMode,
                progress,
                setDarkMode,
                setProgress
            }}
        >{children}</Context.Provider>
    )
}

